window.LOVETC_VARIANT_MAP = {

  // ── Bold Bliss Etc – Zero Gravity Liquid Lipstick (3.5g) ──
  "51135948882194": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "pink",      shade: "KARAOKE NIGHT" },
  "51135948914962": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "brown",     shade: "BEAR HUG" },
  "51135948947730": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "brownpink", shade: "GIRL TRIPPIN" },
  "51135948980498": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "maroon",    shade: "FIRE UP" },
  "51135949013266": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "red",       shade: "WING WOMAN" },
  "51135949046034": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "red",       shade: "INSIDE JOKES" },
  "51135949078802": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "pink",      shade: "GOSSIP SESSION" },
  "51135949111570": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "purple",    shade: "ONE MORE DRINK" },
  "51135949144338": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "brown",     shade: "BROWNIE SUNDAE" },
  "51135949177106": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "pink",      shade: "DANCE ALL NIGHT" },

  // ── Pout Perfect Etc – Moisture Shine Lipstick (4g) ──
  "51640251646226": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "pink" },
  "51640251678994": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "brown" },
  "51640251711762": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "pink" },
  "51640251744530": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "maroon" },
  "51640251777298": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "red" },
  "51640251810066": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "brown" },
  "51640251842834": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "purple" },
  "51640251875602": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "pink" },
  "51640251908370": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "pink" },
  "51640251941138": { handle: "lovetc-pout-perfect-etc-moisture-shine-lipstick-4g", color: "pink" },

  // ── Gloss Glee Etc – High Glaze Lip Gloss (5.5g) ──
  "51135673925906": { handle: "lovetc-gloss-glee-etc-5-5gm", color: "pink" },
  "51135673958674": { handle: "lovetc-gloss-glee-etc-5-5gm", color: "nude" },
  "51135673991442": { handle: "lovetc-gloss-glee-etc-5-5gm", color: "purple" },

  // ── Pout Perfect Etc – High Definition Matte Bullet Lipstick (4.2g) ──
  "51147143479570": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "pink",   shade: "PASSION PROJECT" },
  "51147143512338": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "pink",   shade: "BIRTHDAY BLUSH" },
  "51147143545106": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "pink",   shade: "TAKE A CHANCE" },
  "51147143577874": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "pink",   shade: "DETOX QUEEN" },
  "51147143610642": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "purple", shade: "MIDNIGHT SNACK" },
  "51147143643410": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "red",    shade: "CALL THE SHOTS" },
  "51147143676178": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "red",    shade: "SWEET SWAGGER" },
  "51147143708946": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "red",    shade: "GIRLS DAY OUT" },
  "51147143741714": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "nude",   shade: "COZY LOVE" },
  "51147143774482": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "brown",  shade: "SOLO DATE" },
  "51147143807250": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "brown",  shade: "ESPRESSO CLOCK" },
  "51147143840018": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "brown",  shade: "DESSERT THERAPY" },
  "51147143872786": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "brown",  shade: "SUMMER DAYS" },
  "51147143905554": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "nude",   shade: "Bare & Bold" },
  "51147143938322": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "nude",   shade: "PRINCESS TREATMENT" },
  "51147143971090": { handle: "lovetc-pout-perfect-etc-4-2gm", color: "purple", shade: "GOSSIP GLOW" },

  // ── Melt Miracle Etc – Treatment Oil Infused Lip Balm (3.7g) ──
  "51135726518546": { handle: "lovetc-melt-miracle-etc-3-7gm", color: "purple" },
  "51135726551314": { handle: "lovetc-melt-miracle-etc-3-7gm", color: "pink" },
  "51135726584082": { handle: "lovetc-melt-miracle-etc-3-7gm", color: "brown" },
  "51135726616850": { handle: "lovetc-melt-miracle-etc-3-7gm", color: "red" },

  // ── The Etc Multipurpose Stick (7.5g) ──
  "51853547143442": { handle: "multipurpose-stick", color: "pink" },
  "51853547176210": { handle: "multipurpose-stick", color: "pink" },
  "51853547208978": { handle: "multipurpose-stick", color: "orange" },
  "51853547241746": { handle: "multipurpose-stick", color: "mauve" },
  "51853547274514": { handle: "multipurpose-stick", color: "gold" },
  "51853547307282": { handle: "multipurpose-stick", color: "silver" },

  // ── Gloss Glee Etc – High Glaze Lip Gloss Mini (1.5g) ──
  "51352010817810": { handle: "lovetc-gloss-glee-etc-high-glaze-lip-gloss", color: "pink" },
  "51352010850578": { handle: "lovetc-gloss-glee-etc-high-glaze-lip-gloss", color: "brown" },

  // ── Bold Bliss Etc – Zero Gravity Mini Liquid Lipstick (1.5g) ──
  "51301130174738": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "pink" },
  "51301130207506": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "brown" },
  "51352055939346": { handle: "lovetc-bold-bliss-etc-3-5gm", color: "red" },

  // ── Pout Perfect Etc – Luxe Shimmer Satin Mini Lipstick (1.5g) ──
  "51301123096850": { handle: "lovetc-pout-perfect-etc-luxe-shimmer-satin-mini-lipstick", color: "brown" },
  "51351928930578": { handle: "lovetc-pout-perfect-etc-luxe-shimmer-satin-mini-lipstick", color: "pink" },
  "51351928963346": { handle: "lovetc-pout-perfect-etc-luxe-shimmer-satin-mini-lipstick", color: "red" },

  // ── Pout Perfect Etc – High Definition Matte Mini Lipstick (1.5g) ──
  "51351921393938": { handle: "lovetc-pout-perfect-etc-high-definition-matte-lipstick-mini", color: "magenta" },
  "51351920869650": { handle: "lovetc-pout-perfect-etc-high-definition-matte-lipstick-mini", color: "brown" },
  "51351920804114": { handle: "lovetc-pout-perfect-etc-high-definition-matte-lipstick-mini", color: "brown" },

  // ── Love Bites – Longerwear Lip Colour (3g) ──
  "51853581582610": { handle: "lovetc-love-bites-longerwear-lip-colour", color: "orange" },
  "51853581615378": { handle: "lovetc-love-bites-longerwear-lip-colour", color: "pink" }

};

// ── Helper Functions ──────────────────────────────────────────

function lovetcGetHandle(variantId) {
  var entry = window.LOVETC_VARIANT_MAP[variantId];
  return entry ? entry.handle : null;
}

function lovetcGetProductUrl(variantId) {
  var handle = lovetcGetHandle(variantId);
  return handle ? '/products/' + handle + '?variant=' + variantId : null;
}

function lovetcGetColor(variantId) {
  var entry = window.LOVETC_VARIANT_MAP[variantId];
  return entry ? entry.color : null;
}

function lovetcGetShade(variantId) {
  var entry = window.LOVETC_VARIANT_MAP[variantId];
  return entry ? entry.shade : null;
}